import Vue from 'vue'
import Router from 'vue-router'
import request from './utils/ajax.js'
import util from './utils/util'
import perm from './utils/permission'

let routes = [
    {
        // 根路径默认进首页，未登录时由 beforeEach 拦截跳转到登录页
        path: '/',
        redirect: '/abroad/app/list'
    },
    {
        path: '/login',
        name: 'login',
        component: resolve => require(['./views/user/login'], resolve),
        // 旧登录页面，保留用于兼容
    },
    {
        path: '/login-overseas',
        name: 'login-overseas',
        component: resolve => require(['./views/user/login-overseas'], resolve),
        meta: { title: 'Login - Overseas Account' }
    },
    {
        path: '/signup',
        name: 'signup',
        component: resolve => require(['./views/user/signup-overseas'], resolve),
    },
    {
        path: '/forget',
        name: 'forget',
        component: resolve => require(['./views/user/forget'], resolve),
    },
    {
        path: '/reset',
        name: 'reset',
        component: resolve => require(['./views/user/reset'], resolve),
    },
    {
        path: '/500',
        name: 'error_500',
        component: resolve => require(['./views/error/500.vue'], resolve),
    },
    {
        path: '/401',
        name: 'error_401',
        component: resolve => require(['./views/error/401.vue'], resolve),
    },
    {
        path: '/403',
        name: 'error_403',
        component: resolve => require(['./views/error/403.vue'], resolve),
    },
    {
        path: '/404',
        name: 'error_404',
        component: resolve => require(['./views/error/404.vue'], resolve),
    },


    //海外路由
    {
        path: '/abroad',
        component : resolve => require(['./views/abroad/home/home.vue'], resolve),
        meta: { title: '多盟开发者后台' },
        name: 'abroad',
        redirect: '/abroad/app/list', 
        children: [
            {
                path: 'app',
                meta: { title: '应用列表' },
                name: 'abroad-app',
                component: resolve => require(['./views/abroad/ssp/app/index.vue'], resolve),
                children: [
                    {
                        path: 'list',
                        name: 'app_list',
                        component: resolve => require(['./views/abroad/ssp/app/list'], resolve),
                        meta: { title: '应用列表', keepAlive: true,}
                    },
                ],
            },
            {
                path: 'ad',
                meta: { title: '广告位列表' },
                name: 'abroad-ad',
                component: resolve => require(['./views/abroad/ssp/position/index'], resolve),
                children: [
                    {
                        path: 'list',
                        name: 'ad_list',
                        component: resolve => require(['./views/abroad/ssp/position/list'], resolve),
                        meta: { title: '广告位列表', keepAlive: true,}
                    },
                    {
                        path: 'addAD',
                        name: 'addAD',
                        component: resolve => require(['./views/abroad/ssp/position/advertUpdate'], resolve),
                        meta: { title: '添加广告位' }
                    },
                ],
            },
            {
                path: 'block',
                meta: { title: '屏蔽管理' },
                name: 'abroad-block',
                component: resolve => require(['./views/abroad/ssp/block/index'], resolve),
                children: [
                    {
                        path: 'list',
                        name: 'block_list',
                        component: resolve => require(['./views/abroad/ssp/block/list'], resolve),
                        meta: { title: '屏蔽管理'}
                    },
                ],
            },
            {
                path: 'stats',
                meta: { title: '数据报表' },
                name: 'abroad-stats',
                component: resolve => require(['./views/abroad/ssp/stats/index'], resolve),
                children: [
                    {
                        path: 'info',
                        name: 'stats_info',
                        component: resolve => require(['./views/abroad/ssp/stats/statInfo'], resolve),
                        meta: { title: '数据报表' }
                    } 
                ]
            },
            {
                path: 'doc',
                meta: { title: 'sdk对接' },
                name: 'abroad-sdkDocking',
                component: resolve => require(['./views/abroad/ssp/doc/index'], resolve),
                children: [
                    {
                        path: 'sdkWord',
                        name: 'sdkWord',
                        component: resolve => require(['./views/abroad/ssp/doc/sdkDocking'], resolve),
                        meta: { title: 'sdk对接文档' },
                    },
                    {
                        path: 'sdkTest',
                        name: 'sdkTest',
                        component: resolve => require(['./views/abroad/ssp/doc/sdkTest'], resolve),
                        meta: { title: 'sdk对接文档' },
                    },
                    {
                        path: 'appadsTxt',
                        name: 'appadsTxt',
                        component: resolve => require(['./views/abroad/ssp/doc/appadsTxt'], resolve),
                        meta: { title: 'sdk对接文档' },
                    }
                ],
            }, 
            {
                path: 'account',
                meta: { title: '账户' },
                name: 'abroad-account',
                component: resolve => require(['./views/abroad/ssp/account/index.vue'], resolve),
                redirect:"/abroad/account/companyInfo",
                children: [
                    {
                        path: 'companyInfo',
                        name: 'abroad-account-companyInfo',
                        component: resolve => require(['./views/abroad/ssp/account/companyInfo'], resolve),
                        meta: { title: '企业信息'}
                    },
                    {
                        path: 'subAccount',
                        name: 'abroad-account-subAccount',
                        component: resolve => require(['./views/abroad/ssp/account/subAccount'], resolve),
                        meta: { title: '子账号管理'}
                    }
                ],
            }
        ]
    },
]

Vue.use(Router)


let router = new Router({
    mode: 'hash',
    base: '/',
    routes: routes
})

// 子账号进没授权的页面（直接敲地址等）：直接去 403，明确告诉他没权限。
// 不悄悄跳到别的页面 —— 人本来就在能进的页面上时，跳过去看着像「地址没反应」；
// 也不打回登录页 —— 人是登录着的，重新登录权限也不会变。
// 权限快照拉不到时放行 —— 不能让整个后台打不开；真正的越权后端接口那一层还会再拦一次
function guardPermission(to, next) {
    if (String(to.path).indexOf('/abroad') !== 0) {
        return next()
    }
    perm.load()
        .then(() => {
            if (perm.isMain()) return next()
            let key = perm.menuKeyByPath(to.path)
            // 认不出归属的页面（/abroad 本身、以后新加的页面）不拦
            if (!key) return next()
            let node = perm.findMenu(key)
            // 主账号专属页面（企业信息 / 银行信息 / 子账号管理）子账号永远进不去
            if (node && !perm.isAssignable(node)) return next('/403')
            if (!perm.hasMenu(key)) return next('/403')
            next()
        })
        .catch(() => next())
}

router.beforeEach((to, from, next) => {
    // next();
    // return
    // 如果是从ssp管理后台过来的，并且携带token
    if(to.path == '/app/list' && to.query.token) {
        let params = {
            token: to.query.token
        }
        request.postData("getUserInfo", params, res => {
            // 验证通过
                if(res.token) {
                    util.setCookie("token", res.token, 7)
                    util.setCookie("user", util.userCookieValue(res), 7)
                    // 判断area是2跳转到海外，1跳转到国内
                    if(res.area == 2) {
                        next('/abroad/app/list')
                    } else if(res.area == 1) {
                        next('/app/list')
                    }
                } else {
                    next('/login')
                }
            // 将token存到cookie中
        })
    } else { //多盟开发者后台自行登录
        // 如果用户访问的登录页和注册页，直接放行
        // 免登录白名单
        let paths = ['/login', '/signup', '/forget', '/500', '/401', '/403', '/404']
        if (util.inArray(to.path, paths)) {
            next()
        } else {
            // 从cookie中获取保存的token值
            let token = util.getCookie("token")
            // 没有token，强制跳转到登录页
            if (!token) {
                return next('/login')
            } else {
                guardPermission(to, next)
            }
        }
    }
});

export default router


